import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph } from '@fs/zion-ui'
import useNotifications from '../../../hooks/useNotifications'
import { restoreArtifact } from '../../../services/artifactService'
import { getLastPathElement } from '../../../util/StringUtil'

export default function RestoreSelectedArtifactsOverlay({
  checkedArtifacts,
  setCheckedArtifacts,
  onSuccess,
  patronId,
  ...overlay
}) {
  const { t } = useTranslation()
  const { error, ok } = useNotifications()

  const restoreSelectedOnSubmit = async () => {
    overlay.close()
    const restoreArtifactResponses = await Promise.allSettled(
      checkedArtifacts.map((artifactId) => {
        return restoreArtifact(artifactId, patronId)
      })
    )
    const failedToRestoreArtifactIds = []
    restoreArtifactResponses.forEach((response) => {
      if (response.status === 'rejected') {
        const artifactId = getLastPathElement(response.reason.config.url)
        failedToRestoreArtifactIds.push(artifactId)
      }
    })
    if (restoreArtifactResponses.length === failedToRestoreArtifactIds.length) {
      error(t('artifacts.restoreSelectedAllFailed', 'Error restoring selected artifacts'))
    } else if (failedToRestoreArtifactIds.length > 0) {
      error(
        t(
          'artifacts.restoreSelectedSomeFailed',
          'Error restoring the following artifact IDs: { failedToRestoreArtifactIds }',
          {
            failedToRestoreArtifactIds: failedToRestoreArtifactIds.join(', '),
          }
        )
      )
    } else {
      ok(t('artifacts.restoreSelectedSuccess', 'Restored selected artifacts'))
      onSuccess()
    }
    setCheckedArtifacts((prev) => prev.filter((artifactId) => failedToRestoreArtifactIds.includes(artifactId)))
  }

  return (
    <DialogOverlay title={t('action.restoreSelected', 'Restore Selected')} {...overlay}>
      <Paragraph size="sm">
        {checkedArtifacts && checkedArtifacts.length > 1
          ? t('artifacts.restoreMulipleConfirmation', 'Are you sure you want to restore these artifacts?')
          : t('artifacts.restoreConfirmation', 'Are you sure you want to restore this artifact?')}
      </Paragraph>
      <DialogOverlayActions>
        <Button onClick={restoreSelectedOnSubmit} emphasis="high">
          {t('action.submit', 'Submit')}
        </Button>
        <Button onClick={overlay.close}>{t('action.cancel', 'Cancel')}</Button>
      </DialogOverlayActions>
    </DialogOverlay>
  )
}
